<template>
  <div id="page-container">
    <component :is="currentContainer">
      <router-view v-if="isRouterAlive" />
    </component>
  </div>
</template>

<script setup lang="ts">
import { isMobile } from "@common_lib/base/utils/src/tools"
import { sendMessage } from "@/composables/useBridge"
import { safeLocalStorage } from "@/utils/safeStorage"

const googleAnalytics = useGoogleAnalytics()

useModalStore()
useNavbarStore()

useFraudProtectionSystem()
useReceiveMessage()
useWebsiteErrorRedirect()

// PostMessage 處理 iframe 關閉訊息
const { handleIframeCloseQuery } = usePostMessage()
handleIframeCloseQuery()

const {
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
} = useJBLWebSocket()

useChangeLine({
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
})

useChat()

const components = {
  MobileContainer: defineAsyncComponent(() => import("@/layouts/mobile/Container.vue")),
  DesktopContainer: defineAsyncComponent(() => import("@/layouts/desktop/Container.vue"))
}

const currentContainer = computed(() =>
  isMobile() ? components.MobileContainer : components.DesktopContainer
)

const websiteInfoStore = useWebsiteInfoStore()
const { isRouterAlive, state } = storeToRefs(websiteInfoStore)
const authStore = useAuthStore()
const { isLogin } = storeToRefs(authStore)
const { fetchAccountTracker } = useFetchAccountTracker()
const { fetchFingerprintPro } = useFetchFingerprintPro()

// 一般登入(含 half-login)的 tracking 在 useFetchLogin 的 login()／demoLogin() 登入成功當下打。
// 這裡負責不走登入表單的 API 白牌，在 App 掛載時補打一次。main.js 在 mount 前已 await
// queryInitInfo，此時 store 已有 isFromApi／userID／queryPass。API 白牌且 userID 有值即觸發，
// URL 帶 queryPass 與 single wallet 兩種登入方式都適用；half-login 時 userID 也有值，一併打，
// 與 useFetchLogin 一致。
// 去重 key 用 queryInitInfo 回傳的 queryPass(後端 session id)，同一個 session 重新整理不重複打。
const LAST_TRACKED_QUERY_PASS_KEY = "lastTrackedQueryPass"

const trackWhiteLabelSession = () => {
  const { isFromApi, userID, queryPass } = state.value
  if (!isFromApi || userID === "") return
  if (queryPass === safeLocalStorage.getItem(LAST_TRACKED_QUERY_PASS_KEY)) return
  safeLocalStorage.setItem(LAST_TRACKED_QUERY_PASS_KEY, queryPass)
  fetchAccountTracker().catch(err =>
    console.error("[App] accountTracker API failed", err)
  )
  fetchFingerprintPro().catch(err =>
    console.error("[App] fingerprintPro API failed", err)
  )
}

useBridge()

onMounted(() => {
  trackWhiteLabelSession()

  googleAnalytics.initialize()

  /**
   * APP 橋接
   */
  if (state.value.isMobileAppActive) {
    const cricketUrl = `${window.location.origin}/#/?AppHomeBtn=true`
    sendMessage(
      JSON.stringify({
        sessionId: state.value.queryPass,
        platform: "cricket",
        cricketUrl
      })
    )
    sendMessage(JSON.stringify({ isShowHomeButton: "true" }))

    if (isLogin.value) {
      sendMessage(`{"userId":"${state.value.userID}"}`)
    }
  }
})
</script>

<style lang="scss" scoped></style>
